import { Controller } from "@hotwired/stimulus"

/**
 * Image preview controller
 * Displays a preview of an image file before it is uploaded
 */
export default class extends Controller {
  static targets = ["input", "image"]

  connect() {
    console.log("Image preview controller connected")
  }

  previewImage() {
    const input = this.inputTarget
    const image = this.imageTarget

    if (input.files && input.files[0]) {
      const reader = new FileReader()
      
      reader.onload = (e) => {
        image.src = e.target.result
      }
      
      reader.readAsDataURL(input.files[0])
    }
  }
} 